import useSteps from '../context/steps.context';
const useTypesafeAnswer = (step) => {
    const { stepsState: { answers } } = useSteps();
    const currentAnswer = answers.find(answer => answer.step === step);
    return { currentAnswer };
};
export default useTypesafeAnswer;
//# sourceMappingURL=useTypesafeAnswer.js.map